import _ from 'lodash';
import { getStyleParamsWithDefaults } from '@wix/wixstores-client-common-components/dist/src/outOfIframes/defaultStyleParams/getStyleParamsWithDefaults';
var isMobile = function (formFactor) { return formFactor === "Mobile" /* Mobile */; };
export var WidgetAreaEnum;
(function (WidgetAreaEnum) {
    WidgetAreaEnum["CONTENT"] = "content";
    WidgetAreaEnum["VISUAL"] = "visual";
    WidgetAreaEnum["ALL"] = "all";
})(WidgetAreaEnum || (WidgetAreaEnum = {}));
export var WidgetActionEnum;
(function (WidgetActionEnum) {
    WidgetActionEnum["NAVIGATE"] = "navigate";
    WidgetActionEnum["ADDTOCART"] = "addToCart";
})(WidgetActionEnum || (WidgetActionEnum = {}));
export var ImageScaling;
(function (ImageScaling) {
    ImageScaling["CROP"] = "crop";
    ImageScaling["FIT"] = "fit";
})(ImageScaling || (ImageScaling = {}));
export var WidgetDirectionEnum;
(function (WidgetDirectionEnum) {
    WidgetDirectionEnum["LEFT"] = "left";
    WidgetDirectionEnum["RIGHT"] = "right";
})(WidgetDirectionEnum || (WidgetDirectionEnum = {}));
export var WidgetAlignmentEnum;
(function (WidgetAlignmentEnum) {
    WidgetAlignmentEnum["LEFT"] = "left";
    WidgetAlignmentEnum["CENTER"] = "center";
    WidgetAlignmentEnum["RIGHT"] = "right";
})(WidgetAlignmentEnum || (WidgetAlignmentEnum = {}));
export var WidgetPresetEnum;
(function (WidgetPresetEnum) {
    WidgetPresetEnum["VERTICAL"] = "vertical";
    WidgetPresetEnum["HORIZONTAL"] = "horizontal";
})(WidgetPresetEnum || (WidgetPresetEnum = {}));
export var WidgetPresetIdEnum;
(function (WidgetPresetIdEnum) {
    WidgetPresetIdEnum["VERTICAL"] = "Wix_Store_Product_Widget_Vertical";
    WidgetPresetIdEnum["HORIZONTAL"] = "Wix_Store_Product_Widget_Horizontal";
})(WidgetPresetIdEnum || (WidgetPresetIdEnum = {}));
var fontStyleParam = false;
export var DEFAULT_STYLE_PARAMS = {
    booleans: {
        widgetButtonToggle: true,
        titleToggle: true,
        priceToggle: true,
        separatorToggle: true,
        hoverButtonToggle: false,
        extendOnHoverToggle: true,
        extendOnHolidayToggle: false,
        extendFullImageOnHoverToggle: false,
    },
    numbers: {
        hoverBackgroundColorOpacity: 0,
        hoverBorderSize: 0,
        actionButton_buttonWidth: 0,
        actionButton_borderSize: 0,
        actionButton_cornersRadius: 0,
    },
    fonts: {
        alignment: { value: WidgetAlignmentEnum.CENTER, fontStyleParam: fontStyleParam },
        widgetAction: { value: WidgetActionEnum.NAVIGATE, fontStyleParam: fontStyleParam },
        imageScaling: { value: ImageScaling.CROP, fontStyleParam: fontStyleParam },
        layout: { value: '', fontStyleParam: fontStyleParam },
        widgetDirection: { value: WidgetDirectionEnum.LEFT, fontStyleParam: fontStyleParam },
        hoverArea: { value: WidgetAreaEnum.CONTENT, fontStyleParam: fontStyleParam },
        hoverBorderArea: { value: WidgetAreaEnum.CONTENT, fontStyleParam: fontStyleParam },
        hoverButtonArea: { value: WidgetAreaEnum.CONTENT, fontStyleParam: fontStyleParam },
    },
    colors: {
        hoverBackgroundColor: { value: '' },
        hoverBorderColor: { value: '' },
        actionButton_textColor: { value: '' },
        actionButton_backgroundColor: { value: '' },
        actionButton_borderColor: { value: '' },
        ribbonBackground: { value: '' },
        ribbonText: { value: '' },
    },
};
export function getRuntimeStyleParams(styleParams, _a) {
    var formFactor = _a.formFactor;
    var result = getStyleParamsWithDefaults(styleParams, function () { return ({ defaults: DEFAULT_STYLE_PARAMS }); });
    var mobile = {};
    if (isMobile(formFactor)) {
        mobile = {
        //     booleans: {
        //       productPage_galleryZoom: false,
        //     },
        //     numbers: {
        //       productPage_galleryImageRatio: 2,
        //     },
        //     fonts: {
        //       productPage_galleryNavigationType: {value: GalleryNavigationType.DOTS, fontStyleParam},
        //       productPage_galleryNavigationPosition: {value: GalleryNavigationPosition.BOTTOM, fontStyleParam},
        //       productPage_galleryNavigationLocation: {value: GalleryNavigationLocation.OUTSIDE, fontStyleParam},
        //     },
        };
    }
    return _.merge({}, result, mobile);
}
export function getStyleParamsFromProps(props) {
    var _a = props.globals.style.styleParams, _b = _a.fonts, alignment = _b.alignment.value, widgetAction = _b.widgetAction.value, imageScaling = _b.imageScaling.value, layout = _b.layout.value, widgetDirection = _b.widgetDirection.value, hoverArea = _b.hoverArea.value, hoverBorderArea = _b.hoverBorderArea.value, hoverButtonArea = _b.hoverButtonArea.value, _c = _a.numbers, hoverBackgroundColorOpacity = _c.hoverBackgroundColorOpacity, hoverBorderSize = _c.hoverBorderSize, actionButton_buttonWidth = _c.actionButton_buttonWidth, actionButton_borderSize = _c.actionButton_borderSize, actionButton_cornersRadius = _c.actionButton_cornersRadius, _d = _a.booleans, widgetButtonToggle = _d.widgetButtonToggle, titleToggle = _d.titleToggle, priceToggle = _d.priceToggle, separatorToggle = _d.separatorToggle, hoverButtonToggle = _d.hoverButtonToggle, extendOnHoverToggle = _d.extendOnHoverToggle, extendOnHolidayToggle = _d.extendOnHolidayToggle, extendFullImageOnHoverToggle = _d.extendFullImageOnHoverToggle;
    return {
        alignment: alignment,
        widgetAction: widgetAction,
        imageScaling: imageScaling,
        layout: layout,
        widgetDirection: widgetDirection,
        hoverArea: hoverArea,
        hoverBorderArea: hoverBorderArea,
        hoverButtonArea: hoverButtonArea,
        hoverBackgroundColorOpacity: hoverBackgroundColorOpacity,
        hoverBorderSize: hoverBorderSize,
        actionButton_buttonWidth: actionButton_buttonWidth,
        actionButton_borderSize: actionButton_borderSize,
        actionButton_cornersRadius: actionButton_cornersRadius,
        widgetButtonToggle: widgetButtonToggle,
        titleToggle: titleToggle,
        priceToggle: priceToggle,
        separatorToggle: separatorToggle,
        hoverButtonToggle: hoverButtonToggle,
        extendOnHoverToggle: extendOnHoverToggle,
        extendOnHolidayToggle: extendOnHolidayToggle,
        extendFullImageOnHoverToggle: extendFullImageOnHoverToggle,
    };
}
export function getLayoutIdFromProps(props) {
    var layoutId = props.globals.style.styleParams.fonts.layout.value;
    return layoutId;
}
//# sourceMappingURL=styleParamsService.js.map